import React from 'react'
import { Link } from 'react-router-dom'
import logo1 from '../assets/logo1.webp'
import logo2 from '../assets/logo2.webp'
import logo3 from '../assets/logo3.webp'
import logo4 from '../assets/logo4.webp'
import logo5 from '../assets/logo5.webp'

import bg2 from '../assets/bg2.webp'

export default function Contact() {


  return (<div>

    <div className=' bg-hero-pattern -z-10' >
      <div className=' flex justify-center items-center  flex-col bg-[rgb(59,68,152,0.9)] bg-cover bg-no-repeat  h-[60vh]   text-white xl:px-[9vw]  text-center   ' >
        <p
          className='text-xl tracking-wide  p-2'>CONTACT  </p>
        <h1 h1 className='text-4xl lg:text-7xl p-2 tracking-wide font-semibold'>Get in Touch</h1>
        <span className='mt-2 p-3 text-xl font-sans '>
          <Link to='/home' className='hover:text-gray-400'>Home</Link> / Contact
        </span>
      </div>
    </div>

    <div className='flex bg-[#F5F8FF] flex-col  m-4 lg:flex-row justify-center items-center' >

      <div className='text-center m-4' >
        <p className='text-[#009640] text-2xl tracking-wide '>APPOINTMENT</p>
        <h1 className=' text-4xl lg:text-6xl   sm:mt-5 text-blue-900 tracking-wider py-3 ' >Book your <span className='text-[#009640]'>Dentist </span>  for <span className='text-[#009640]'>Poper </span>  care</h1>
        <form className='flex flex-col  m-4 space-y-3    '>

          <select className='rounded shadow-xl   p-2 font-sans    text-blue-900' >
            <option value="Root Canal">Root Canal</option>
            <option value="Root Canal">Scaling</option>
            <option value="Root Canal">Flavor</option>
            <option value="Root Canal">Crown</option>
          </select>
          <select className='rounded shadow-lg p-2 font-sans    text-blue-900'>
            <option value="Root Canal">Doctor</option>
            <option value="Root Canal">Julia</option>
            <option value="Root Canal">Thomas</option>
            <option value="Root Canal">Rebalica</option>
          </select>
          <input type="text" className='rounded shadow-lg p-2 font-sans  text-blue-900' placeholder='Name' />
          <input type="email" className='rounded shadow-lg p-2 font-sans  text-blue-900' name="" placeholder='Email' id="" />
          <input type="text" className='rounded shadow-lg p-2 font-sans  text-blue-900' placeholder='Phone' />
          <p className='text-green-900 underline hover:text-blue-900 text-lg font-medium' >Make Appointment</p>
        </form>
      </div>
      <img src={bg2} alt="bg2" className='lg:w-[45vw]' />
    </div>

    <div className='flex flex-wrap my-10 gap-10 justify-evenly items-center ' >
      <img src={logo1} alt="logo1" />
      <img src={logo2} alt="logo1" />
      <img src={logo3} alt="logo1" />
      <img src={logo4} alt="logo1" />
      <img src={logo5} alt="logo1" />
    </div>

    <div className="flex flex-col sm:flex-row text-white px-5 justify-between lg:px-28 py-10 bg-[#009640] ">
      <div> <p className=' text-2xl tracking-wide'>NEWSLETTER</p>
        <h1 className=' text-4xl lg:text-5xl font-semibold  sm:mt-3 tracking-wide py-3 ' > Subscribe our Newsletter</h1></div>
      <div>
        <input type="text" className='p-2 bg-transparent sm:-ml-6 h-10 text-white font-sans border-2 border-white' placeholder=' Enter Your Email Address' /><button className='bg-[rgb(63,65,153)]  font-sans h-10 px-2' >Subscribe</button>
      </div>
    </div>

  </div>
  )
}
